/**
 * Extracts the numeric page ID from a Confluence page URL.
 *
 * Takes the URL as an argument instead of reading `window.location`, so hosts that are not on the
 * page they are asking about can use it: the Rovo browser extension's chat lives in a Chrome side
 * panel, where `window.location` is the panel. `getCurrentPageId` is the `window.location` wrapper.
 */
export const getConfluenceContentIdFromUrl = (pageUrl: string | undefined): string | undefined => {
	return pageUrl?.match(/\/pages\/(?:edit-v2\/)?(\d+)/)?.[1];
};
